import React from 'react'
import { Badge, Icon } from '@atoms'
import { getIcon } from '@/utils/getIcon'

interface CommodityBadgeProps {
    label: string
    commodityTypeId: number
}

const CommodityBadge: React.FC<CommodityBadgeProps> = ({
    label,
    commodityTypeId,
}) => {
    return (
        <div className="group relative flex cursor-default items-center">
            <Badge>
                <span className="flex items-center gap-1">
                    <Icon
                        name={getIcon(commodityTypeId)}
                        size="small"
                        data-testid={`${String(commodityTypeId)}-icon`}
                    />
                    {label}
                </span>
            </Badge>
        </div>
    )
}

export default CommodityBadge
